module.exports = __webpack_public_path__ + "static/villa-mobil-mockup-48ba4fc322b1911c6c8b278bac3b087b.png";